!(function() {
  document.addEventListener('DOMContentLoaded', function() {
    const modalList = document.querySelectorAll('[data-custom-modal-popup]')
    modalList.forEach(function(modal) {
      const modalId = modal.getAttribute('data-target')

      const showModalAutomatically = modal.getAttribute('data-show-automatically') === 'true'
      if (showModalAutomatically) {
        setTimeout(function() { modal.style.display = 'flex'; }, 3000)
      }

      document.querySelectorAll('[href="#' + modalId + '"]').forEach(function(link) {
        link.addEventListener('click', function(event) {
          event.preventDefault()
          modal.style.display = 'flex'
        })
      })

      modal.querySelectorAll('.custom-modal-close-button, .custom-modal-mask, .custom-modal-close-button-mobile').forEach(function(element) {
        element.addEventListener('click', function() {
          modal.style.display = 'none'
        })
      })
    })
  })
})()